import { render, staticRenderFns } from "./Powderlist.vue?vue&type=template&id=2bc49c62&"
import script from "./Powderlist.vue?vue&type=script&lang=js&"
export * from "./Powderlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports